export const FindArrayValue = (filter, key) => {
  var FilteredValue;
  let dataFilter = filter?.filter((item) => Object.keys(item)[0] == key);
  if (dataFilter?.length > 0) {
    let value = dataFilter[0];
    FilteredValue = value[key];
  }
  return FilteredValue;
};
